import { render } from "./CookiebarCookie.ce.vue?vue&type=template&id=0c9b1f4c"
import script from "./CookiebarCookie.ce.vue?vue&type=script&lang=js"
export * from "./CookiebarCookie.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__